export default "__VITE_ASSET__CICsL2ND__"